"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendFullStoryEvent = void 0;
var _1 = require(".");
// Note that both 'eventName' and 'eventProperties' here must conform to FullStory's requirements,
// otherwise your event will be silently rejected! The requirements are discussed here:
// https://help.fullstory.com/hc/en-us/articles/360020623274#Limitations%20&%20Guidelines
exports.sendFullStoryEvent = function (eventName, eventProperties) {
    var _a;
    if (eventProperties === void 0) { eventProperties = {}; }
    if ((_a = window) === null || _a === void 0 ? void 0 : _a.DEBUG) {
        console.info("\u2139\uFE0F Would have sent FullStory event \"" + eventName + "\"", eventProperties);
        return;
    }
    if (!_1.isFullStoryInstalled()) {
        return; // bail silently, we don't want to throw an error here
    }
    _1.getFullStory().event(eventName, eventProperties);
};
